/* @flow */
// typecheck: ignore file
import React from 'react';
import cx from 'classnames';
import Organization from 'entities/Organization';
import ScrollWatch from 'components/ScrollWatch.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';

import './styles/SchoolTableBody.scss';

type Props = {
  disabled: boolean,
  schools: Organization[],
  allLoaded: boolean,
  loadNextPage: () => any,
};

class SchoolTableBody extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  go = (school: Organization) => this.context.router.push({ pathname: `admin/schools/${school.id}` });

  render() {
    const rows = this.props.schools.map(school => {
      const statistics = school.getStatistics();
      const onClick = this.props.disabled ? undefined : () => this.go(school);
      const classes = cx('SchoolTableBody-row', {
        'SchoolTableBody-row--enabled': !this.props.disabled,
      });

      return (
        <tr key={school.id} className={classes} onClick={onClick}>
          <td>
            {school.getName()}
          </td>
          <td>
            {statistics && statistics.teacher_count}
          </td>
          <td>
            {statistics && statistics.subscriber_count}
          </td>
          <td>
            {statistics && statistics.class_count}
          </td>
          <td>
            {statistics && statistics.message_count}
          </td>
        </tr>
      );
    });

    return (
      <tbody>
        {rows}
        {!this.props.allLoaded &&
          <tr>
            <td colSpan={99} className="PeopleTableBody-loading">
              <ScrollWatch onEnter={this.props.loadNextPage} threshold={0.2}>
                <LoadingIndicator size="large" />
              </ScrollWatch>
            </td>
          </tr>
        }
      </tbody>
    );
  }
}

export default SchoolTableBody;



// WEBPACK FOOTER //
// ./src/admin/components/SchoolTableBody.jsx